export default __webpack_public_path__ + "locales/en/ChangePasswordDialog.json?hash=7d98c259aa29a7fabc771de113b90ca0";